module.exports = __webpack_public_path__ + "static/media/CHIRAG JI_page-0001.59a6882f.jpg";